import { Content } from 'pages/ParentHelper/components/History/components/Content';
import { NewChatButton } from 'pages/ParentHelper/components/History/components/NewChatButton';

import { Wrapper } from './components/Wrapper';

export const HistoryDesktop = () => (
  <Wrapper>
    <NewChatButton />
    <Content />
  </Wrapper>
);
